var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeStrikethrough({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85216 6.397C7.85216 6.74575 7.94554 7.05062 8.15591 7.31275H6.53929C6.46281 7.03427 6.42533 6.74653 6.42791 6.45775C6.42791 4.62737 8.04341 3.34375 10.3429 3.34375C12.558 3.34375 14.1567 4.66563 14.2185 6.55H12.8348C12.711 5.335 11.7503 4.58913 10.3035 4.58913C8.91979 4.58913 7.85104 5.26637 7.85104 6.397H7.85216ZM10.3204 14.8097C7.89829 14.8097 6.28279 13.5644 6.15229 11.6485H7.53604C7.69804 12.841 8.80616 13.5644 10.398 13.5644C11.9055 13.5644 12.9968 12.7712 12.9968 11.68C12.9968 10.7496 12.3814 10.1342 10.8435 9.79562L9.77929 9.56275H1.85254V8.43775H17.6025V9.56275H13.6605C14.187 10.0544 14.4199 10.681 14.4199 11.4719C14.4199 13.5261 12.8044 14.8097 10.3204 14.8097Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeStrikethrough);
export default __webpack_public_path__ + "static/media/type-strikethrough.e0328c76bc9666a61a35ea9dbd7b8f0b.svg";
export { ForwardRef as ReactComponent };